import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { DemoModeProvider } from './contexts/DemoModeContext';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <DemoModeProvider>
        <App />
      </DemoModeProvider>
    </BrowserRouter>
  </StrictMode>
);